<template>
  <div class="setup-new-profile">
    <div class="container">
      <div class="set-up-border-wrapper bg-white">
        <h1>Setup Profile</h1>
        <p>Proceed by create an avatar with your own photo</p>
        <div class="row my-0 pt-3">
          <div class="col-md-12">
            <div class="create-avatar-wrapper position-relative">
              <div class="create-av-back">
                <v-btn width="105" depressed color="#fff"> Back </v-btn>
              </div>

              <img
                src="../../assets/Images/new-interface/3d-image.png"
                alt="female"
              />
              <v-btn
                class="btn-change-avater-bg"
                @click.stop="drawer = !drawer"
                dark
                color="rgba(0, 0, 0,0.8 )"
              >
              <img
                src="../../assets/Images/new-interface/change-bg.svg"
                alt="change-bg" class="mr-2"
              />
                 Change Background
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div class="setup-precess-btm my-3 text-center">
        <v-btn
          outlined
          color="#000"
          height="45"
          width="150"
          class="bg-white mr-2 px-5"
        >
          Skip
        </v-btn>
        <v-btn
          outlined
          color="primary"
          height="45"
          class="border-primary mr-2 px-5"
        >
          Proceed with Images
        </v-btn>
        <v-btn color="primary" height="45" class="px-5" width="150">
          Use Avatar
        </v-btn>
      </div>
    </div>
    <!--drawer start-->
    <v-navigation-drawer v-model="drawer" fixed temporary right class="select-profile-bg" width="384" color="#15191c">
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
        <h4 class="text-white">Change Background</h4>
          <v-list-item class="image-box-bg-wrap">
           <div class="image-box-main selected">
            <div class="image-box">

            </div>
            <p>BG01</p>
           </div>
          
          </v-list-item>
          <v-list-item class="image-box-bg-wrap">
           <div class="image-box-main ">
            <div class="image-box image-box-2" >

            </div>
            <p>BG02</p>
           </div>
          </v-list-item>
          <v-list-item class="image-box-bg-wrap">
           <div class="image-box-main ">
            <div class="image-box  image-box-3">

            </div>
            <p>BG03</p>
           </div>
          </v-list-item>
           <v-list-item class="image-box-bg-wrap">
           <div class="image-box-main ">
            <div class="image-box  image-box-4">

            </div>
            <p>BG04</p>
           </div>
          </v-list-item>
           <v-list-item class="image-box-bg-wrap">
           <div class="image-box-main ">
            <div class="image-box  image-box-5">

            </div>
            <p>BG05</p>
           </div>
          </v-list-item>
          <v-list-item class="image-box-bg-wrap">
           <div class="image-box-main ">
            <div class="image-box  image-box-6">

            </div>
            <p>BG05</p>
           </div>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <!--drawer end-->
  </div>
</template>
<script>
export default {
  data() {
    return {
      drawer: null,
      
    };
  },
};
</script>


